import { Api } from "./Api";
import {
  Issue,
  IssueByYear,
  CreateIssueBody,
  LastFiveSoldIssues,
  MostSoldIssues,
  EditIssueBody,
} from "./types";

export const IssueApi = {
  async getAllIssues() {
    try {
      const { data: response } = await Api.get<{ payload?: Issue[] }>(
        `/issues/get-all`
      );
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async getIssuesByYear() {
    try {
      const { data: response } = await Api.get<{ payload?: IssueByYear[] }>(
        `/issues/get-issues-by-year`
      );
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
  async createNewIssue(issueData: CreateIssueBody) {
    try {
      const { data: response } = await Api.post(`/issues/create`, issueData);
      return response;
    } catch (error) {
      console.error(error);
    }
  },
  async editIssue(id: number, issueData: EditIssueBody) {
    try {
      const { data: response } = await Api.patch(
        `/issues/${id}/update`,
        issueData
      );
      return response;
    } catch (error) {
      console.error(error);
    }
  },
  async deleteIssue(id: number) {
    try {
      const { data: response } = await Api.delete(`/issues/${id}/delete`);
      return response;
    } catch (error) {
      console.error(error);
    }
  },
  async getLastFiveIssuesSales() {
    try {
      const { data: response } = await Api.get<{
        payload?: LastFiveSoldIssues[];
      }>(`/issues/last-five-sales`);
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },

  async getMostSoldIssues() {
    try {
      const { data: response } = await Api.get<{ payload?: MostSoldIssues[] }>(
        `/issues/most-sold`
      );
      return response.payload ?? null;
    } catch (error) {
      console.log(error);
    }
  },
};
